export default __webpack_public_path__ + "static/media/litho-demo-travel-agency.bab17f63.jpg";